<template>
  <div v-wechat-title="titleTop">

      <div class="topIcon">
        <i class="iconfont iconsuccess"/>
      </div>
      <div class="title1">感谢您的评价</div>
      <div class="title2">船公司评价将发送至您的邮箱</div>

  </div>
</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { Uploader, Button, Popup, Field, Toast,RadioGroup, Radio,Checkbox ,Picker } from 'vant'
import { getUrlKey,compressorImageList, GetEnumList, MyNotify, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import FieldSelect from '@/components/FieldSelect'
import { GetSelfUrl } from '@/utils/request'

export default {
  components: {
    [Uploader.name]: Uploader,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Checkbox.name]: Checkbox,
    [Picker.name]: Picker,
    TopBar,
    FieldSelect
  },
  props: {
    // eslint-disable-next-line
    value:undefined,
  },
  data() {
    return {
      system:'',
      titleTop: '酷潜船宿精选',
      showShare: false,
      shareTitle: '',
      shareAbout: '',
      shareTimeline: '',
      shareUrl: '',
      shareIcon: ''
    }
  },
  watch: {
    
  },
  created() {
    this.system = getUrlKey('system')

  },
  methods: {
    GetEnumList,
    MyNotify,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
  }
}
</script>

<style scoped>

.topIcon{
  margin-top: 20vh;
  text-align: center;
  margin-left: calc(50vw - 1.25em);
  height: 2.5em;
  line-height: 2.5em;
  width: 2.5em;
  border-radius: 2.5em;
  background-color: #00B83E;
  color: #fff;
}
.topIcon i{
  font-size: 2em;
}
.title1{
  margin:1em 0;
  text-align: center;
  font-weight: 700;
}
.title2{
  text-align: center;
  font-size: 0.8em;
  color: #999;
}
</style>
